<template>
    <div>
        <div class="m-portlet m-b-10">
            <div class="m-portlet__body">
                <el-form label-width="100px">
                    <el-row :gutter="6">
                        <el-col :span="12">
                            <el-form-item label="学生">
                                <el-select v-model="student_id"
                                           remote
                                           clearable
                                           filterable
                                           :remote-method="handleChooseStudent"
                                           @change="handleStudents()"
                                           placeholder="请选择学生">
                                    <el-option
                                            v-for="item in $parentInfo.Dialog_ChooseStudent.choose_students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="签到状态">
                                <el-select v-model="status"
                                           remote
                                           clearable
                                           filterable
                                           @change="handleStudents()"
                                           placeholder="请选择状态">
                                    <el-option
                                            v-for="item in choose_status"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-0">
            <div class="m-portlet__body" v-loading="$parentInfo.Dialog_ChooseStudent.loading">
                <el-table
                        :data="$parentInfo.Dialog_ChooseStudent.students"
                        height="400px"
                        style="width: 100%"
                        size="middle">
                    <el-table-column prop="student_id" label="ID" align="center" min-width="10%"></el-table-column>
                    <el-table-column prop="student_name" label="名字" align="center" min-width="10%"></el-table-column>
                    <el-table-column prop="class_name" label="班级" align="center" min-width="20%"></el-table-column>
                    <el-table-column prop="teacher_name" label="老师" align="center" min-width="10%"></el-table-column>
                    <el-table-column prop="time" label="时间" align="center" min-width="20%"></el-table-column>
                    <el-table-column prop="classroom_name" label="教室" align="center" min-width="20%"></el-table-column>
                    <el-table-column label="状态" align="center" min-width="10%">
                        <template slot-scope="scope">
                            <span v-if="$parentInfo.Dialog_ChooseStudent.classPlan_status[scope.row.status]">
                                {{$parentInfo.Dialog_ChooseStudent.classPlan_status[scope.row.status].remark}}
                            </span>
                            <span v-else>
                                 无
                            </span>

                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="$parentInfo.Dialog_ChooseStudent.currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="$parentInfo.Dialog_ChooseStudent.total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ChooseStudent",
        data() {
            return {
                value1: [new Date(2020, 1, 1, 8, 0), new Date(2020, 1, 1, 23, 59)],
                name:'',
                classroom_num:'',
                student_id:'',
                status:'',
                classroom_names:[],
                classroom_nums:[],
                choose_status:[
                    {
                        id:'active',
                        name:'未上'
                    },
                    {
                        id:'finished',
                        name:'签到'
                    },
                    {
                        id:'leaving',
                        name:'请假'
                    },
                    {
                        id:'absent',
                        name:'缺席'
                    },
                    {
                        id:'truancy',
                        name:'旷课'
                    },
                    {
                        id:'orgReason',
                        name:'机构原因'
                    },
                    {
                        id:'applyForRefund',
                        name:'退费申请'
                    },
                    {
                        id:'applyForLeave',
                        name:'请假申请'
                    },
                ]
            }
        },
        mounted() {

        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleStudents()
            this.handleChooseStudent()
        },
        methods: {
            handleStudents(currentPage=1){
                if (currentPage===1){
                    this.$parentInfo.Dialog_ChooseStudent.currentPage=1
                }
                this.$parentInfo.Dialog_ChooseFreeClassroom.loading=true
                this.$wApi.send(this.$parentInfo.path, 'get_dailyTable_student', {
                    'date': this.$parentInfo.filter.date,
                    'section_id': this.$parentInfo.filter.section_id,
                    'currentPage': currentPage,
                    'currentPageSize': this.$parentInfo.Dialog_ChooseStudent.currentPageSize,
                    'student_id':this.student_id,
                    'status':this.status
                });
            },
            handleChooseStudent(query){
                if(!query){
                    query=''
                }
                this.$wApi.send(this.$parentInfo.path, 'choose_student', {
                    'section_id': this.$parentInfo.filter.section_id,
                    'date': this.$parentInfo.filter.date,
                    'name':query,
                });
            },
            handleSizeChange(val) {
                this.$parentInfo.Dialog_ChooseStudent.currentPageSize = val;
                this.handleStudents(this.$parentInfo.Dialog_ChooseStudent.currentPage)
            },
            handleCurrentChange(val) {
                this.$parentInfo.Dialog_ChooseStudent.currentPage = val;
                this.handleStudents(this.$parentInfo.Dialog_ChooseStudent.currentPage)
            },
        }
    }
</script>

<style scoped>

</style>